import { Navigate, useLocation } from 'react-router-dom'
import { LoadingScreen } from '../common/LoadingScreen'
import { useAuth } from '../../context/AuthContext'

export function ProtectedRoute({ children }) {
  const { user, isAdmin, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div className="pt-24"><LoadingScreen label="Yetki kontrol ediliyor…" /></div>
  if (!user || !isAdmin) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />

  return children
}
